import { updateDoc, doc } from "firebase/firestore";
import db from "../../firebase/db";

import SET_USER from "./SET_USER";
import updateUser from "./actions/updateUser";
import auth from "@/firebase/auth";

const state = {
  user: {
    uid: null,
    email: null,
    displayName: null,
    title: null,
    photoURL: null,
    admin: false,
    emailVerified: false,
    language: null,
  },
};

const mutations = {
  SET_USER,
};

const getters = {
  isLoggedIn(state) {
    return !!state.user.email;
  },
  getUser(state) {
    return state.user;
  },
  isEmailVerified(state) {
    return state.user.emailVerified;
  },
  isAdmin(state) {
    return state.user.admin;
  },
};

const actions = {
  logout({ state }) {
    state.user.email = null;
  },
  async setLanguage({ state, commit }, locale) {
    if (locale !== state.user.language) {
      commit("SET_USER", {
        language: locale,
      });
    }
    if (state.user.uid !== null) {
      auth.languageCode = state.user.language;
      await updateDoc(doc(db, "users", state.user.uid), {
        language: locale,
      }).catch((error) => {
        commit("SET_INIT_ERROR", error, { root: true });
      });
    }
  },
  updateUser,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
